// import UsersDetail from "./Detail";
import UsersList from "./List";

export { UsersList };
